import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Step,
    StepLabel,
    StepContent,
    Grid,
    Stepper,
    Button,
    Typography
} from '@material-ui/core';

import { Translate } from '../Localization/Translate';
import SummaryBox from './SummaryBox';
import Contact from './steps/Contact';
import SelectPump from './steps/SelectPump';
import Power from './steps/Power';
import CoolingAndWarmWater from './steps/CoolingAndWarmWater';
import Summary from './steps/Summary';

import Api from '../../nibeApi';

class NibeForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentLoaded: false,

            // Stepper
            activeStep: 0,
            topAvailableStep: 0,
            maxActiveStep: 0,

            // Customer
            userExists: false,
            userNotActive: false,
            addNewUser: false,
            activationEmailValue: null,
            activationProjectNameValue: null,
            customerActivationDataObject: {},
            customerDataObject: {},
            coolingAndWarmWaterObject: {
                quotePersons: 1,
                tapWaterKnown: false
            },

            // PumpType
            pumpsLoaded: false,
            pumptypes: [],
            pump: '',
            pumpType: '',
            powerIsKnown: undefined,
            selectedPumpObject: null,

            // Power
            power: 0,
            powerValues: {
                power: 0,
                livingArea: 0,
                ventilationType: 0,
                buildingType: '',
                buildingYear: 2000,
                gasUsage: 0,
            },

            // Summary box
            showSummaryData: false,
            summaryData: {
                pumpType: {
                    title: Translate("QuoteTool/step2/pumptypelabel"),
                    value: '-',
                },
                pump: {
                    title: Translate("QuoteTool/step2/pumplabel"),
                    value: '-',
                },
                power: {
                    title: Translate("QuoteTool/step3/quotepowerlabel"),
                    value: '-',
                },
                gasUsage: {
                    title: Translate("QuoteTool/step3/gasusage"),
                    value: '-',
                },
                cooling: {
                    title: Translate("QuoteTool/step4/quotecoolinglabel"),
                    value: '-',
                },
                tapwater: {
                    title: Translate("QuoteTool/step4/quotewaterlabel"),
                    value: '-',
                },
                waterConsumption: {
                    title: Translate('QuoteTool/summary/waterconsumption'),
                    value: '-',
                }
            },
            classes: '',
        };

        this.checkEmailFieldRef = React.createRef();
        this.divRef = React.createRef();
        this.newQuote = this.newQuote.bind(this);
        this.calculatePowerValue = this.calculatePowerValue.bind(this);
    }

    buildingTypeEnum = {
        renovation: 1,
        newBuilding: 2,
    }

    componentDidMount() {

        this.getPumps();

        this.setState({
            componentLoaded: true
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.state.powerIsKnown
            && (prevState.powerValues !== this.state.powerValues
                || prevState.coolingAndWarmWaterObject.quotePersons !== this.state.coolingAndWarmWaterObject.quotePersons)) {
            const calculatedPower = this.calculatePowerValue();
            this.updateState("power", calculatedPower);
        }

        if (prevState.activeStep !== this.state.activeStep && this.state.activeStep > this.state.maxActiveStep) {
            this.setState({ 'maxActiveStep': this.state.activeStep });
        }

        if ((prevState.pump !== this.state.pump || prevState.pumpType !== this.state.pumpType)) {
            this.resetStateDueToNewPump();
        }
    }

    resetStateDueToNewPump = () => {
        this.setState({
            ...this.state,
            powerValues: {
                power: 0,
                livingArea: 0,
                ventilationType: 0,
                buildingType: '',
                buildingYear: 2000,
                gasUsage: 0,
            },
            activeStep: 1,
            maxActiveStep: 1,
            coolingAndWarmWaterObject: {},
            power: 0,
            powerIsKnown: undefined,
            summaryData: {
                ...this.state.summaryData,
                power: {
                    title: Translate("QuoteTool/step3/quotepowerlabel"),
                    value: '-',
                },
                cooling: {
                    title: Translate("QuoteTool/step4/quotecoolinglabel"),
                    value: '-',
                },
                tapwater: {
                    title: Translate("QuoteTool/step4/quotewaterlabel"),
                    value: '-',
                },
                waterConsumption: {
                    title: Translate('QuoteTool/summary/waterconsumption'),
                    value: '-',
                }
            }
        });
    }

    newQuote = () => {
        this.setState({
            ...this.state,
            powerValues: {
                power: 0,
                livingArea: 0,
                ventilationType: 0,
                buildingType: '',
                buildingYear: 2000,
                gasUsage: 0,
            },
            pump: '',
            pumpType: '',
            activeStep: 1,
            maxActiveStep: 1,
            coolingAndWarmWaterObject: {},
            power: 0,
            gasUsage: '',
            powerIsKnown: undefined,
            summaryData: {
                pumpType: {
                    title: Translate("QuoteTool/step2/pumptypelabel"),
                    value: '-',
                },
                pump: {
                    title: Translate("QuoteTool/step2/pumplabel"),
                    value: '-',
                },
                power: {
                    title: Translate("QuoteTool/step3/quotepowerlabel"),
                    value: '-',
                },
                gasUsage: {
                    title: Translate("QuoteTool/step3/gasusage"),
                    value: '-',
                },
                cooling: {
                    title: Translate("QuoteTool/step4/quotecoolinglabel"),
                    value: '-',
                },
                tapwater: {
                    title: Translate("QuoteTool/step4/quotewaterlabel"),
                    value: '-',
                },
                waterConsumption: {
                    title: Translate('QuoteTool/summary/waterconsumption'),
                    value: '-',
                }
            }
        });
    }

    getNumberOfSteps() {
        return 5;
    }

    // Get content based on which step is active
    getStepContent(step) {
        switch (step) {
            case 0:
                return (
                    <div>
                        {Translate('QuoteTool/step1/stepingress')}
                    </div>
                );
            case 1:
                return (
                    <div>
                        <Typography>{Translate('QuoteTool/step2/stepingress')}</Typography>
                    </div>
                );
            case 2:
                return (
                    <div>
                        <Typography>{Translate('QuoteTool/step3/stepingress')}</Typography>
                    </div>
                );
            case 3:
                return (
                    <div>
                        <Typography>{Translate('QuoteTool/step4/stepingress')}</Typography>
                    </div>
                );
            default:
                return '';
        }
    }

    updateSteps(activeStep, topAvailableStep) {
        this.setState({
            activeStep,
            topAvailableStep,
        });
    }

    updateState(objectName, objectValue) {
        this.updateSummary(objectName, objectValue);
        this.setState({
            [objectName]: objectValue
        });
    }

    updateSummary(objectName, objectValue) {

        const summaryData = { ...this.state.summaryData };
        if (summaryData) {
            if (summaryData[objectName]) {
                summaryData[objectName].value = objectValue;
                this.setState({
                    summaryData,
                    showSummaryData: true
                });
            }
        }
    }

    updateInputData(elementName, value) {

        this.setState({
            [elementName]: value,
        });
    }

    getPumps = () => {
        const scope = this;
        // const { emailCheckValue } = this.state;
        const { config } = this.props;

        Api.makeCall("get", `Pumps?market=${config}`, {}, false, function (response) {

            if (response && response.data) {

                const pumptypes = response.data;

                if (pumptypes) {

                    scope.setState({
                        pumptypes,
                        pumpsLoaded: true
                    });
                }
            }
        }, function (reason) {

        });
    };

    calculateRenovation() {
        let yearMultiplier = 0;
        switch (this.state.powerValues.buildingYear) {
            case 1900:
                yearMultiplier = 4.4;
                break;
            case 1990:
                yearMultiplier = 4.8;
                break;
            case 2000:
                yearMultiplier = 5.2;
                break;
            default:
                yearMultiplier = 5.2;
        }
        return (((this.state.powerValues.gasUsage - (this.state.coolingAndWarmWaterObject.quotePersons * 100)) * yearMultiplier) / 1000).toFixed(2);
    }

    calculateNewBuilding() {
        let area = this.state.powerValues.livingArea;
        let ventilationValue = this.state.powerValues.ventilationValue;
        let ventilation = 40;

        if (this.state.pumpType !== 'vw') {
            switch (ventilationValue) {
                case 'mv':
                    ventilation = 40;
                    break;
                case 'co2':
                    ventilation = 35;
                    break;
                case 'wtw':
                    ventilation = 30;
                    break;
                default:
                    ventilation = 40;
            }
        }

        return (area * (ventilation / 1000)).toFixed(2);
    }

    calculatePowerValue() {
        let area = this.state.powerValues.livingArea;
        let ventilationValue = this.state.powerValues.ventilationValue;

        if ((!area || !ventilationValue) && this.state.powerValues.buildingType === this.buildingTypeEnum.newBuilding) {
            return false;
        }

        let calculatedPower = 0
        switch (this.state.powerValues.buildingType) {
            case this.buildingTypeEnum.newBuilding:
                calculatedPower = this.calculateNewBuilding();
                break;
            case this.buildingTypeEnum.renovation:
                calculatedPower = this.calculateRenovation();
                break;
        }

        return calculatedPower;
    }

    sendNibeForm = (formName) => {
        const scope = this;
        const { emailCheckValue } = this.state;
        const { config } = this.props;

        switch (formName) {
            case 'emailCheck':

                // j.raatjes@breman.nl
                Api.makeCall("get", `Contacts/?emailAddress=${encodeURI(emailCheckValue)}&market=${config}`, {}, false, function (response) {

                    if (response && response.data.contactid) {
                        scope.setState({
                            userExists: true,
                            activeStep: 1,
                            topAvailableStep: 1
                        });
                    }
                }, function (reason) {
                    scope.setState({
                        addNewUser: true,
                    });

                });
                break;
            default:
                break;
        }
    };

    // Update the active state according to the next button press
    handleNext = () => {
        const { activeStep } = this.state;
        this.setState({
            activeStep: activeStep + 1
        });
    };

    // Similar for back and reset buttons
    handleBack = () => {
        const { activeStep } = this.state;
        this.setState({
            activeStep: activeStep - 1,
        });
    };

    handleReset = () => {
        this.setState({
            activeStep: 0,
        });
    };

    setActiveStep = (step) => {
        if (step <= this.state.maxActiveStep) {
            this.setState({ 'activeStep': step });
        }
    }

    render() {
        const classes = makeStyles((theme) => ({
            root: {
                width: '100%',
            },
        }));

        const { language, config, siteId } = this.props;
        const { activeStep, topAvailableStep, componentLoaded, userExists, summaryData, showSummaryData, addNewUser, customerDataObject, customerActivationDataObject, pump, pumpType, powerValues, userNotActive, pumptypes, coolingAndWarmWaterObject, powerIsKnown, selectedPumpObject, powerValuesLocal, power, activationProjectNameValue } = this.state;
        return (

            <div className="nibe-quote__form-content">
                <SummaryBox {...{ summaryData, showSummaryData, coolingAndWarmWaterObject, powerValues }} />
                <Grid container alignItems="flex-start" spacing={2}>
                    <Grid item xs={12}>
                        {componentLoaded &&
                            <div>
                                {false &&
                                    <h1>NIBE <small>( {language} - {config} - {siteId} )</small></h1>
                                }
                                <Stepper activeStep={activeStep} orientation="vertical">
                                    <Step key={0}>
                                        <StepLabel onClick={() => this.setActiveStep(0)} className={this.state.maxActiveStep >= 0 ? 'nibe_hasBeenActive' : ''}>{Translate('QuoteTool/step1/steptitle')}</StepLabel>
                                        <StepContent>
                                            <div className="nibe-quote__ingress">{Translate('QuoteTool/step1/stepingress')}</div>
                                            <Contact config={this.props.config} {...{ updateSteps: (activeStep, topAvailableStep) => this.updateSteps(activeStep, topAvailableStep), updateState: (stateName, stateValue) => this.updateState(stateName, stateValue), addNewUser, userExists, customerDataObject, customerActivationDataObject, userNotActive, activationProjectNameValue }} />
                                        </StepContent>
                                    </Step>
                                    <Step key={1}>
                                        <StepLabel onClick={() => this.setActiveStep(1)} className={this.state.maxActiveStep >= 1 ? 'nibe_hasBeenActive' : ''}>{Translate('QuoteTool/step2/steptitle')}</StepLabel>
                                        <StepContent>
                                            <div className="nibe-quote__ingress">{Translate('QuoteTool/step2/stepingress')}</div>
                                            <SelectPump {...{ updateSteps: (activeStep, topAvailableStep) => this.updateSteps(activeStep, topAvailableStep), updateState: (stateName, stateValue) => this.updateState(stateName, stateValue), addNewUser, userExists, pump, pumpType, activeStep, pumptypes }} />
                                        </StepContent>

                                    </Step>
                                    <Step key={2}>
                                        <StepLabel onClick={() => this.setActiveStep(2)} className={this.state.maxActiveStep >= 2 ? 'nibe_hasBeenActive' : ''}>{Translate('QuoteTool/step3/steptitle')}</StepLabel>
                                        <StepContent>
                                            <div className="nibe-quote__ingress">{Translate('QuoteTool/step3/stepingress')}</div>
                                            <Power {...{ updateSteps: (activeStep, topAvailableStep) => this.updateSteps(activeStep, topAvailableStep), updateState: (stateName, stateValue) => this.updateState(stateName, stateValue), powerValues, activeStep, pumpType, powerIsKnown, coolingAndWarmWaterObject, selectedPumpObject, powerValuesLocal, power }} />
                                        </StepContent>
                                    </Step>
                                    <Step key={3}>
                                        <StepLabel onClick={() => this.setActiveStep(3)} className={this.state.maxActiveStep >= 3 ? 'nibe_hasBeenActive' : ''}>{Translate('QuoteTool/step4/steptitle')}</StepLabel>
                                        <StepContent>
                                            <div className="nibe-quote__ingress">{Translate('QuoteTool/step4/stepingress')}</div>
                                            <CoolingAndWarmWater config={this.props.config} {...{ updateSteps: (activeStep, topAvailableStep) => this.updateSteps(activeStep, topAvailableStep), updateState: (stateName, stateValue) => this.updateState(stateName, stateValue), addNewUser, userExists, activeStep, coolingAndWarmWaterObject, pumpType, selectedPumpObject }} />
                                        </StepContent>
                                    </Step>
                                    <Step key={4}>
                                        <StepLabel onClick={() => this.setActiveStep(4)} className={this.state.maxActiveStep >= 4 ? 'nibe_hasBeenActive' : ''}>{Translate('QuoteTool/step5/steptitle')}</StepLabel>
                                        <StepContent>
                                            <Summary power={this.state.power} email={this.state.activationEmailValue} projectName={this.state.activationProjectNameValue} config={this.props.config} {...{ updateSteps: (activeStep, topAvailableStep) => this.updateSteps(activeStep, topAvailableStep), updateState: (stateName, stateValue) => this.updateState(stateName, stateValue), addNewUser, userExists, activeStep, summaryData, showSummaryData, coolingAndWarmWaterObject, powerValues }} />
                                        </StepContent>
                                    </Step>
                                </Stepper>
                                {activeStep > 4 ? <div className='nibe-quote__thank-you-step'>
                                    <h5 className='nibe-quote__thank-you'>{Translate('QuoteTool/thankyou')}</h5>
                                    <Button variant='contained' color='primary' onClick={() => this.setActiveStep(0)}>{Translate('QuoteTool/newquote')}</Button>
                                </div> : null}
                            </div>
                        }
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default NibeForm;